import InvoiceVerification from "../../components/screen/purchaseOnlinePbf/InvoiceVerification";

// Tanpa HOC: halaman ini dibuka lewat QR di lembar faktur, oleh siapa pun yang
// memegang kertasnya — petugas penerimaan, kurir, pemeriksa — jadi tidak boleh
// menuntut login. Tanpa PageTemplate juga, karena tidak ada sidebar/header
// aplikasi untuk pengunjung yang tidak punya akun.
const InvoiceVerificationPage = () => {
  return <InvoiceVerification />;
};

export default InvoiceVerificationPage;
